import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "shortcuts-buttons" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "label" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "label" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "label" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "label" }

import {
    BaseIcon,
    BidHammerIcon,
    AutoIcon,
    CurrencyIcon,
    LockIcon,
    PauseIcon,
    PlayIcon,
    UndoIcon,
    UnlockIcon,
    ManualIcon
  } from "@/components/icons";
  import Api from "@/services/api";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { computed, inject, markRaw, nextTick, reactive, ref } from "vue";
  import { trans } from "@/utils/trans";
  import Popup from "@/components/_partials/Popup.vue";
  import InstantBreakPopup from "@/components/_partials/InstantBreakPopup.vue";
  import ChangePricePopup from "@/components/_partials/ChangePricePopup.vue";
  import { useToast } from "primevue/usetoast";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardPopup',
  emits: ["closeForm", "changeTitle", "setModalHeightAuto"],
  setup(__props, { emit: __emit }) {

  const auctionStore = useAuctionStore();
  const auction = computed(() => auctionStore.auction);
  const activeLot = computed(() => auctionStore.activeLot);

  const emitter = inject("emitter");
  const toast = useToast();

  const popup = ref<typeof Popup>();
  const changePricePopup = ref<typeof Popup>();
  const breakComponent = markRaw(InstantBreakPopup);
  const changePriceComponent = markRaw(ChangePricePopup);

  const emit = __emit;

  const waitServer = reactive({
    break: false,
    auctionType: false,
    bookBidFirst: false,
    retractBid: false
  });

  const liveBreakEnd = computed(() => auction.value.live_break_end);
  const breakButtonLabel = computed(() => {
    return trans("live.common.shortcuts." + (liveBreakEnd.value ? "resume_auction" : "instant_break"));
  });

  const isAutomatedLive = computed(() => {
    return (
      auctionStore.liveSettings?.is_open_next_lot_auto &&
      auctionStore.liveSettings?.is_change_bidding_status_auto &&
      auctionStore.liveSettings?.is_complete_current_lot_auto
    );
  });
  const auctionTypeLabel = computed(() => {
    return trans("live.common.shortcuts." + (!isAutomatedLive.value ? "run_auto" : "run_manual"));
  });

  const blockButtonsText = computed(() => {
    return trans("live.common.shortcuts." + (!auctionStore.isLockedButtons ? "block_buttons" : "unlock_buttons"));
  });

  const toggleBreakAuction = () => {
    auctionStore.setBreak();
    // if (!liveBreakEnd.value) {
    //   popup.value?.toggleComponent(breakComponent);
    //   nextTick(() => {
    //     popup.value?.open();
    //   });
    // }
  };

  const toggleAutoAuction = () => {
    if (waitServer.auctionType) return;
    waitServer.auctionType = true;

    const settings = isAutomatedLive.value
      ? { is_open_next_lot_auto: false, is_change_bidding_status_auto: false, is_complete_current_lot_auto: false }
      : { is_open_next_lot_auto: true, is_change_bidding_status_auto: true, is_complete_current_lot_auto: true };

    Api.put(auctionStore.routes["auctions.update_live_settings"], settings)
      .then((response) => {
        if (response.data.status && response.data.settings) {
          auctionStore.$patch(response.data.settings);
        } else {
          console.log(response);
        }
      })
      .finally(() => {
        waitServer.auctionType = false;
      });
  };

  const toggleLockButtons = () => {
    auctionStore.$patch({
      isLockedButtons: !auctionStore.isLockedButtons
    });
  };

  const bookBidFirst = () => {
    alert("In development");
    emit("closeForm");
  };

  const changePrice = () => {
    if (auctionStore.activeLot?.id) {
      auctionStore.activeLot.bid_increment_rules = auctionStore.auction.bid_increment_rules;
      auctionStore.activeLot.bid_variants = auctionStore.auction.bid_variants;
      auctionStore.activeLot.bid_infinite_step = auctionStore.auction.bid_infinite_step;
      auctionStore.activeLot.bid_on_starting_price = auctionStore.auction.bid_on_starting_price;
      changePricePopup.value?.toggleComponent(changePriceComponent);

      nextTick(() => {
        changePricePopup.value?.open();
      });
    } else {
      toast.add({
        severity: "error",
        summary: trans("live.toast.error"),
        detail: trans("No active lot"),
        life: 6000
      });
    }
  };

  const retractBid = () => {
    emitter?.emit("shortcuts:retract-bid");
    emit("closeForm");
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "btn btn-blue-outline btn-rounded",
        onClick: toggleBreakAuction
      }, [
        (liveBreakEnd.value)
          ? (_openBlock(), _createBlock(_unref(BaseIcon), {
              key: 0,
              "icon-name": "play",
              width: "29",
              height: "37",
              "view-box": "0 0 29 36.908"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(PlayIcon))
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_unref(BaseIcon), {
              key: 1,
              "icon-name": "pause",
              width: "31",
              height: "36",
              "view-box": "0 0 30.721 35.841"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(PauseIcon))
              ]),
              _: 1
            })),
        _createElementVNode("span", _hoisted_2, _toDisplayString(breakButtonLabel.value), 1)
      ]),
      _createElementVNode("button", {
        class: "btn btn-blue-outline btn-rounded",
        disabled: waitServer.auctionType,
        onClick: toggleAutoAuction
      }, [
        (isAutomatedLive.value)
          ? (_openBlock(), _createBlock(_unref(BaseIcon), {
              key: 0,
              "icon-name": "manual",
              width: "38",
              height: "38",
              "view-box": "0 0 37.718 37.718"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ManualIcon))
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_unref(BaseIcon), {
              key: 1,
              "icon-name": "auto",
              width: "38",
              height: "38",
              "view-box": "0 0 38.269 38.269"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(AutoIcon))
              ]),
              _: 1
            })),
        _createElementVNode("span", _hoisted_4, _toDisplayString(auctionTypeLabel.value), 1)
      ], 8, _hoisted_3),
      _createElementVNode("button", {
        class: "btn btn-blue-outline btn-rounded",
        onClick: toggleLockButtons
      }, [
        (!_unref(auctionStore).isLockedButtons)
          ? (_openBlock(), _createBlock(_unref(BaseIcon), {
              key: 0,
              "icon-name": "lock",
              width: "29",
              height: "38",
              "view-box": "0 0 17.721 23.259"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(LockIcon))
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_unref(BaseIcon), {
              key: 1,
              "icon-name": "unlock",
              width: "29",
              height: "38",
              "view-box": "0 0 18 24"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(UnlockIcon))
              ]),
              _: 1
            })),
        _createElementVNode("span", _hoisted_5, _toDisplayString(blockButtonsText.value), 1)
      ]),
      _createElementVNode("button", {
        class: "btn btn-blue-outline btn-rounded",
        disabled: waitServer.bookBidFirst,
        onClick: bookBidFirst
      }, [
        _createVNode(_unref(BaseIcon), {
          "icon-name": "book-bid",
          width: "37",
          height: "38",
          "view-box": "0 0 36.663 38.013"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BidHammerIcon))
          ]),
          _: 1
        }),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(trans)("live.common.shortcuts.book_bid_first")), 1)
      ], 8, _hoisted_6),
      _createElementVNode("button", {
        class: "btn btn-blue-outline btn-rounded",
        onClick: changePrice,
        disabled: !_unref(auctionStore).activeLot?.id
      }, [
        _createVNode(_unref(BaseIcon), {
          "icon-name": "currency",
          width: "21",
          height: "38",
          "view-box": "0 0 21.499 38.013"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(CurrencyIcon))
          ]),
          _: 1
        }),
        _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(trans)("live.common.shortcuts.change_price")), 1)
      ], 8, _hoisted_8),
      _createElementVNode("button", {
        disabled: !activeLot.value?.leaders_list?.length || waitServer.retractBid,
        class: "btn btn-blue-outline btn-rounded",
        onClick: retractBid
      }, [
        _createVNode(_unref(BaseIcon), {
          "icon-name": "undo",
          width: "41",
          height: "18",
          "view-box": "0 0 41.272 18.145"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(UndoIcon))
          ]),
          _: 1
        }),
        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(trans)("live.common.shortcuts.retract_bid")), 1)
      ], 8, _hoisted_10)
    ]),
    _createVNode(Popup, {
      class: "instant-break-popup",
      title: "Make an Instant Break",
      ref_key: "popup",
      ref: popup
    }, null, 512),
    _createVNode(Popup, {
      class: "change-price-popup",
      "z-index": 14,
      title: _unref(trans)('live.modals.change_price.title'),
      ref_key: "changePricePopup",
      ref: changePricePopup
    }, null, 8, ["title"])
  ], 64))
}
}

})